module.exports = __webpack_public_path__ + "img/4c.13036334.png";